import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getPondsRows, MAX_POND_SECTIONS } from "../../../utils/stormBuildUpPonds";
import { COLORS } from "../../../utils/constants";

type PondsTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  onAddPond: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  exTopsoilMm?: number;
  pondTopsoilThicknessMm?: Record<string, number>;
  sectionTitles?: Record<string, string>;
};

export default function PondsTable({ sectionCount, onAddPond, onDeleteSection, onConfigureSection, exTopsoilMm, pondTopsoilThicknessMm, sectionTitles, ...props }: PondsTableProps) {
  return (
    <div>
      <StormBuildUpTable
        rows={getPondsRows(sectionCount, exTopsoilMm, pondTopsoilThicknessMm, sectionTitles)}
        onDeleteSection={onDeleteSection}
        onConfigureSection={onConfigureSection}
        {...props}
      />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddPond}
          disabled={sectionCount >= MAX_POND_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Pond
        </Button>
      </div>
    </div>
  );
}
